import axios from 'axios';
import Common from '../../componets/Common';

export const generarPension = async (studentCode, invoice, authPayment) => {
  const resNuevaOrden = await axios
  .get(
    `${Common.urlAPI}/GenerarPension/${studentCode}/${invoice}`,
    authPayment
  )
  .catch((error) => {
    if (error.response.status === 401) {
      alert("El token es invalido para este usuario");
    }
  });

  if (resNuevaOrden.data.state === "NOK") {
    alert(
      "La orden de pago ha sido pagada y se encuentra validando en el sistema."
    );
  } else {
    window.location = resNuevaOrden.data.url;
    console.log(resNuevaOrden.data.url);
  }

  // return resNuevaOrden;
}
